/* --------- Default Imports ----------- */

import React from 'react'
import ReactDOM from 'react-dom';

/* -------- Redux ------- */
import { Provider } from 'react-redux';

//reducers
import store from "./redux/store/indexStore";

/* --------- Components ----------- */

//component imports
import RouterView from "./router/RouterView";

/* --------- CSS ----------- */

//import sfu style css
import './assets/css/clf.css';

//css files
import './index.css';

//import css for reactprime, NOTE an error appears if you try to import with web pack immediately on npm run build but not after uncommenting it out after it npm starts
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

//import for PrimeFlex for columns support
import './assets/css/primeflex.css';

/* --------- Fonts, Icons ----------- */

//import all font awesome free icon library
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

// Add all icons to the library so you can use it in your page
library.add(fas, far, fab);

//TODO allows for store debug, remove when not needed, use store.getState() to see whats in the react redux store
//window.store = store;

//rendering the virtual dom
ReactDOM.render(
    <Provider store={store}>
        <RouterView/>
    </Provider>
    , document.getElementById('root')
);

